import { message } from 'antd'
import { MRNApi } from '../../../../api/HSEQ/MRN'
import MRNLines from '../../../../components/HSEQ/MRN/Lines/MRNLines'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import useModalData from '../../../../elements/Hooks/useModalData'
import { pick } from 'lodash'
import React from 'react'

function MRNLinesCont (props) {
  const { mrn, isUpdatable } = props
  const { list, fetching, fetch } = useFetchList(() => MRNApi.getLinesByMRN(mrn._key))

  const {
    visible,
    modalType,
    object: line,
    submitting,
    setSubmitting,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    checkForm,
    update,
  } = useModalData(undefined, MRNApi.lines.update, MRNApi.lines.remove, fetch)

  async function submit () {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await MRNApi.lines.create({
        ...newObject,
        mrn: pick(mrn, '_id'),
      })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <MRNLines
      {...{
        list,
        isUpdatable,
        fetching,
        fetch,
        visible,
        submitting,
        mrn,
        line,
        onShow,
        onCancel,
        submit,
        removing,
        remove,
        update,
        modalType,
        formRef,
      }}
    />
  )
}

MRNLinesCont.propTypes = {}
MRNLinesCont.defaultProps = {}

export default (MRNLinesCont)
